// Modules
import React, { useState, useEffect } from 'react';
import { withRouter, useParams, Link, useLocation, Redirect } from 'react-router-dom';
import ActionList from '@ingka/action-list';
import Layout from 'Components/layout/Layout.jsx';
import BCrumb from 'Components/Bcrumb/BCrumb.jsx';
import Headline from 'Components/headline/Headline.jsx';
import StatusOrder from 'Components/statusOrder/StatusOrder.jsx';
import Topic from 'Components/topic/Topic.jsx';

import { setSelectedContactId } from 'Store/reducer/selectedContactPage';
import { selectSelectedTopic } from 'Store/selectors/index';
import { ROUTE_BASE, ROUTE_HOME } from 'Constants/routes';

// styles
import './GetHelp.scss';
import { useGetTopicQuery } from 'Services/api/index';
import { useAppDispatch, useAppSelector } from 'Store/index';
import Loader from '../../components/loading/Loader';
import TopicsBlockSkeleton from '../home/TopicsBlock.skeleton';
import { sendAnalyticEvent } from '../../utils/analytics';

const GetHelp = () => {
    // Hooks
    const location = useLocation();

    const dispatch = useAppDispatch();

    const { data: pages, isLoading: loadingPages } = useGetTopicQuery();

    const { selectedTopicId } = useParams();

    // Recommended topics of the current selected topic
    const [selectedTopicDetails, setSelectedTopicDetails] = useState({});
    const [hasRecommendation, setHasRecommendation] = useState({});
    const [redirect, setRedirect] = useState(false);

    // to obtain the suptopic name  who call this component for Analytic
    const selectedTopic = useAppSelector(selectSelectedTopic);

    const getBeforeTopicName = () => {
        const topic = pages.topics.find(({ id }) => id === selectedTopic);
        return topic?.topicHeadline;
    };

    const sendToAnalytics = (suggestedTopic) => {
        sendAnalyticEvent({
            action: getBeforeTopicName(),
            category: `CSP-2-${suggestedTopic.topicHeadline}`,
        });
    };

    const topicClickHandler = (suggestedTopic) => {
        if (getBeforeTopicName() && suggestedTopic) sendToAnalytics(suggestedTopic);
        dispatch(setSelectedContactId({ contactId: suggestedTopic.id }));
    };

    useEffect(() => {
        if (pages) {
            setRedirect(!pages.topics.find(({ id }) => id === selectedTopicId));
            setSelectedTopicDetails(pages.topics.find(({ id }) => id === selectedTopicId));
        }

        if (selectedTopicDetails) {
            setHasRecommendation(selectedTopicDetails.recommendation);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pages, selectedTopicDetails, selectedTopicId]);

    // Send current page visit to GA engine

    useEffect(() => {
        const currentPath = location.pathname + location.search;
        sendAnalyticEvent({ category: 'pageview', pagePath: currentPath });
    }, [location]);

    return (
        <Layout>
            <BCrumb />
            <Loader isLoading={loadingPages}>
                <Headline
                    title={selectedTopicDetails?.headline}
                    description={selectedTopicDetails?.body}
                />
            </Loader>
            {hasRecommendation ? (
                <StatusOrder
                    heading={hasRecommendation.headline}
                    content={hasRecommendation.body}
                    urlButton={hasRecommendation.callToActionUrl}
                    label={hasRecommendation.callToActionText}
                />
            ) : null}
            {loadingPages && <TopicsBlockSkeleton length={9} isLayoutAdditional={false} />}
            {selectedTopicDetails?.topics ? (
                <ActionList className="topics-container" data-cy="subtopics-list" id="getHelpList">
                    {selectedTopicDetails.topics.map((suggestedTopic, index) => (
                        <li className="list" key={suggestedTopic.id}>
                            <Link
                                key={suggestedTopic.id}
                                to={`${ROUTE_BASE}/a/${suggestedTopic.id}/`}
                                className="topic-link"
                                tabIndex="-1"
                            >
                                <Topic
                                    id={`getHelp-${index}`}
                                    label={suggestedTopic?.topicHeadline}
                                    caption={suggestedTopic?.topicBody}
                                    clickHandler={() => topicClickHandler(suggestedTopic)}
                                />
                            </Link>
                        </li>
                    ))}
                </ActionList>
            ) : (
                redirect && <Redirect to={ROUTE_HOME} />
            )}
        </Layout>
    );
};
export default withRouter(GetHelp);
